<template>
  <div class="container">
    <div class="detail-content">
      <slot />
    </div>
    <div class="btn-group" v-if="showBtn">
      <slot name="btn-group">
        <el-button type="primary" @click="$emit('pass')">审核通过</el-button>
        <el-button type="default" @click="$emit('refuse')">审核拒绝</el-button>
      </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "Detail-layer",
  props: {
    showBtn: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style scoped lang="scss">
.container {
  height: 100%;
  display: flex;
  flex-direction: column;
  width: 100%;
  position: relative;
}
.detail-content {
  flex: 1;
  height: 0;
  min-height: 0;
  position: relative;
}

.btn-group {
  margin: 10px 0;
}
</style>
